// extracted by mini-css-extract-plugin
module.exports = {"main":"Main_main__2NlBM"};